import { useEffect, useState } from 'react';
import useAxios from './useAxios';

const useFormStackForm = formCode => {
    const [ formContent, setFormContent ] = useState();
    const { get } = useAxios();

    const fetchFormContent = async () => {
        try {
            const remoteFormHtml = await get(`/api/cms/GetFormStackForm?formCode=${formCode}`);
            if (remoteFormHtml) {
                const cleaned = remoteFormHtml?.endsWith('"\n");') ? remoteFormHtml.substring(0, remoteFormHtml.length - 6) : remoteFormHtml;
                setFormContent(cleaned);
            }
        } catch (err) {}
    };


    useEffect(() => {
        if (!formContent) {
            fetchFormContent();
        }
    }, []);

    return formContent;
};

export default useFormStackForm;
